import React from "react"
import {IonItem, IonLabel, IonNote} from "@ionic/react";

interface props {
    dateTime: string | undefined | null
    label:    string
}

const DateTimeListItem: React.FC<props> = ( {dateTime, label} ) => {

    let displayDateTime: string = '-';

    if (dateTime) {
        const newDateTime = new Date(dateTime)

        displayDateTime = newDateTime.toLocaleString(
            (navigator.language || "nl-NL"),
            {
                weekday : 'short',
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }
        )
    }

    return (
        <IonItem lines="full">
            <IonLabel>{label}</IonLabel>
            <IonNote className="ion-padding-vertical" slot="end">
                {displayDateTime || '-'}
            </IonNote>
        </IonItem>
    )
}

export default DateTimeListItem